"use client"

import Link from "next/link"
import { useState, useEffect } from "react"
import { Mail } from "lucide-react"
import Image from "next/image"
import { TeamMember } from "./team-member"
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { InternMember } from "./intern-member"
import { EmailModal } from "./email-modal"
import { Button } from "@/components/ui/button"
import { 
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from "@/components/ui/hover-card"

export function SharedFooter() {
  const [isEmailModalOpen, setIsEmailModalOpen] = useState(false)
  const [mounted, setMounted] = useState(false)
  
  useEffect(() => {
    setMounted(true)
  }, [])

  return (
    <footer className="border-t bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="container mx-auto px-4 py-3">
        <div className="flex flex-col sm:flex-row justify-between items-center gap-3">
          <div className="flex items-center">
            {mounted && (
              <Image 
                src="/images/trpc-logo-long.png" 
                alt="The Rapid Prototyping Company" 
                width={160}
                height={20}
                className="h-4 w-auto opacity-80 hover:opacity-100 transition-opacity"
                priority={false}
              />
            )}
          </div>
          
          <div className="flex items-center gap-4">
            {/* HIDDEN — Intern to CEO blog link. Restore when re-enabling the AI intern program.
            <Link href="/blog">
              <Button variant="ghost" size="sm">
                The Intern to CEO Blog
              </Button>
            </Link>
            */}

            {/* Team Members */}
            <div className="flex items-center gap-2">
              <TeamMember
                imageSrc="/images/khurram.png"
                name="Khurram Ahmad"
                displayName="Khurram"
                linkedinUrl="https://www.linkedin.com/in/khurramahmad"
                twitterUrl="https://x.com/koojam"
                emailDestination="khurram@trpc.me"
              />
              <TeamMember
                imageSrc="/images/scobel.png"
                name="Matt Scobel"
                displayName="Matt"
                linkedinUrl="https://www.linkedin.com/in/scobel"
                twitterUrl="https://x.com/scobelverse"
              />
              {/* HIDDEN — AI Intern footer icon. Restore alongside intern flow. */}
              {/* <InternMember /> */}
            </div>

            {/* Contact Section */}
            <HoverCard>
              <HoverCardTrigger asChild>
                <Button variant="outline" size="sm">
                  Contact
                </Button>
              </HoverCardTrigger>
              <HoverCardContent className="w-auto p-2">
                <div className="flex items-center gap-2">
                  <Link
                    href="https://www.linkedin.com/company/the-rapid-prototyping-company"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Button variant="ghost" size="icon" className="h-8 w-8">
                      <Image src="/icons/linkedin.svg" alt="LinkedIn" width={16} height={16} className="h-4 w-4 dark:invert" />
                      <span className="sr-only">LinkedIn</span>
                    </Button>
                  </Link>
                  <Button 
                    variant="ghost" 
                    size="icon" 
                    className="h-8 w-8"
                    onClick={() => setIsEmailModalOpen(true)}
                  >
                    <Mail className="h-4 w-4" />
                    <span className="sr-only">Email</span>
                  </Button>
                </div>
              </HoverCardContent>
            </HoverCard>
          </div>
        </div>
      </div>

      {/* Email Modal */}
      <EmailModal isOpen={isEmailModalOpen} onClose={() => setIsEmailModalOpen(false)} />
    </footer>
  )
}
